<template>
  <!--<transition name="forward">-->
  <div v-show="takeoutOrderedIsShow">
    <div class="content">
      <div class="takeout">
        <div class="font-0-8 text-left padding-10 bg-brown"><strong>配送信息</strong></div>
        <bg-yun>
        <div class="padding-10 font-0-8">
          <div>配送方式： <span class="color-black">{{userTakeoutInfo.deliveryType==0?"自提":"外送"}}</span></div>
        </div>
        <div class="padding-10 border-t-dash" v-if="userTakeoutInfo.deliveryType==0">
            <div class="font-0-8 ">
              门店地址：<span class="color-black">{{takeoutConfig.address}},{{takeoutConfig.houseNo}}</span>
              <span class="color-gray font-0-8">,联系电话:{{takeoutConfig.telephone}}</span>
              <span class="color-blue" @click="editDelivery();">[修改]</span>
            </div>
        </div>
        <div class="padding-10 border-t-dash" v-if="userTakeoutInfo.deliveryType==1">
          <div class="font-0-8 ">
            收货详情：<span class="color-black">{{userTakeoutInfo.address}}</span>
            <span class="color-red" v-if="userTakeoutInfo.distance>0">{{parseData(userTakeoutInfo.distance/1000)}}</span>
            <span class="color-black font-0-8">
              ,{{userTakeoutInfo.username}}:{{userTakeoutInfo.tel}}
            </span>
            <span class="color-blue" @click="editDelivery();">[修改]</span>
          </div>
        </div>
        <div class="padding-10 font-0-8 border-t-dash" v-if="userTakeoutInfo.deliveryType==0 && userTakeoutInfo.timeText">
          <div>自提时间：
            <span class="color-black">{{userTakeoutInfo.timeText}}</span>
          </div>
        </div>
        <div class="padding-10 font-0-8 border-t-dash" v-if="userTakeoutInfo.deliveryType==1">
          <div>配送时间：
            <span class="color-black">{{userTakeoutInfo.timeText}}</span>
          </div>
        </div>
        <div class="padding-10 font-0-8 border-t-dash" v-if="userTakeoutInfo.deliveryType==1">
          <div v-if="takeoutConfig.distributionCharge>0">配送费：
            <span class="color-red" v-if="billHead.amount*100 <takeoutConfig.sendRule">{{(takeoutConfig.distributionCharge*0.01)*1}}元</span>
            <span class="color-red" style="text-decoration: line-through;" v-if="billHead.amount*100 >=takeoutConfig.sendRule">{{(takeoutConfig.distributionCharge*0.01)*1}}元</span>
            <span class="font-0-8 magin-l-6" v-if="takeoutConfig.sendRule>=0 && takeoutConfig.sendRule<10000">{{parseData2((takeoutConfig.sendRule*0.01)*1)}}</span>
          </div>
          <div v-if="takeoutConfig.distributionCharge<=0">配送费：
            <span class="color-red">免费</span>
          </div>
        </div>
        </bg-yun>
      </div>
      <div class="menu">
        <div class="font-0-8 text-left padding-10 bg-brown line-solid"><strong>菜品详情</strong><br>如需对菜品添加制作要求，请点击菜品名称添加</div>
        <!--非套餐-->
        <div v-for="type in billDtl">
          <div class="typename text-center">
            <!--大类名称-->
            <div class="padding-5-10 font-0-9 bg-yellow">{{type.name}} {{type.menuItem.length}}道</div>
          </div>
          <div  v-for="(order,orderIndex) in type.menuItem">
            <bg-yun>
              <!--菜品信息-->
              <div class="padding-5 flex-layout bg-white">
                <div class="flex4 flex-layout padding-5">

                  <div class="flex3" @click.stop="clickOrder(order)">
                    <div class="font-0-9 text-nowrap">{{order.name}}</div>
                    <div class="font-0-8 text-nowrap">
                      <span class="color-red">{{order.price*1}}</span>元<span v-if="order.standard">/{{order.standard}}</span>
                      <span class="color-yellow" v-if="order.memo">[{{order.memo}}]</span>
                    </div>
                  </div>
                </div>
                <!--数量加减-->
                <div class="flex-2 flex-layout">
                  <div class="flex1" @click.stop="clickSub(type,order,orderIndex)">
                    <img src="../../assets/image/subIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                  </div>
                  <div class="flex1">
                    <div class="order-num font-0-6">{{order.num}}</div>
                  </div>
                  <div class="flex1" @click.stop="clickAdd(type,order)">
                    <img src="../../assets/image/addIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                  </div>
                </div>
              </div>
              <!--配菜-->
              <div class="bg-white padding-10 flex-layout font-0-7 border-t-dash" v-for="item in order.menuItem">
                <div class="flex1 text-left padding-L-25">{{item.num}} ×{{item.standard}}</div>
                <div class="flex4 padding-l-5">{{item.name}}  <span class="color-yellow" v-if="item.memo">[{{item.memo}}]</span></div>
                <div class="flex-2 color-yellow" style="text-align: right" v-if="type.isGroup == 0">{{item.price*1}}元 /{{item.standard}}</div>
              </div>
            </bg-yun>
          </div>
        </div>

        <!--套餐-->

        <div v-if="suitBillDtl.length>0">
          <div class="typename text-center">
            <!--大类名称-->
            <div class="padding-5-10 font-0-9 bg-yellow">套餐 {{suitBillDtl.length}}道</div>
          </div>
          <div  v-for="(order,index) in suitBillDtl">
            <bg-yun>
              <!--菜品信息-->
              <div class="padding-5 flex-layout bg-white">
                <div class="flex4 flex-layout padding-5">

                  <div class="flex3" @click.stop="clickOrder(order)">
                    <div class="font-0-9 text-nowrap">{{order.name}}</div>
                    <div class="font-0-8 text-nowrap">
                      <span class="color-red">{{order.price*1}}</span>元<span v-if="order.standard">/{{order.standard}}</span>
                      <span class="color-yellow" v-if="order.memo">[{{order.memo}}]</span>
                    </div>
                  </div>
                </div>
                <!--数量加减-->
                <div class="flex-2 flex-layout">
                  <div class="flex1" @click.stop="clickSuitSub(suitBillDtl,order,index)">
                    <img src="../../assets/image/subIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                  </div>
                  <div class="flex1">
                    <div class="order-num font-0-6">{{order.num * 1}}</div>
                  </div>
                  <div class="flex1" @click.stop="clickSuitAdd(order)">
                    <img src="../../assets/image/addIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                  </div>
                </div>
              </div>
              <!--配菜-->
              <div class="bg-white padding-10 flex-layout font-0-7 border-t-dash" v-for="item in order.menuItem">
                <div class="flex1 text-left padding-L-25">{{item.num * 1}} ×{{item.standard}}</div>
                <div class="flex4 padding-l-5">{{item.name}}  <span class="color-yellow" v-if="item.memo">[{{item.memo}}]</span></div>
              </div>
            </bg-yun>
          </div>
        </div>
      </div>
      <div class="memo">
        <bg-yun>
          <div class="flex-row padding-10 font-0-9" @click="addOrderMemo()">
            <div >订单备注：</div>
            <div class="flex1 text-left font-0-9">{{billHead.billMemo}}</div>
            <img class="right-icon" src="../../assets/image/cancel.svg" width="20">
          </div>
        </bg-yun>
      </div>
    </div>
    <div class="footer flex-row">
      <div class="add-order" @click="clickGoAdd()">
        <div>加菜</div>
      </div>
      <div class="amount">
        <div class="order-amount">{{billHead.amount*1}}<span>元</span></div>
        <div class="delivery-amount" v-if="userTakeoutInfo.deliveryType==1 && takeoutConfig.distributionCharge>0 && billHead.amount*100<takeoutConfig.sendRule">另需配送费:{{(takeoutConfig.distributionCharge*0.01)*1}}元</div>
      </div>
      <div class="pay un-business" v-if="takeoutConfig.isBusiness!=1 && takeoutConfig.businessTime">
        <div class="send-amount">未营业</div>
        <div class="delta">({{takeoutConfig.businessTime[0].startTime}}-{{takeoutConfig.businessTime[0].endTime}})</div>
      </div>
      <div class="pay go-pay" v-if="takeoutConfig.isBusiness==1 && (userTakeoutInfo.deliveryType==0 || billHead.amount*100 >= takeoutConfig.sendAmount)" @click="clickGoPay()">
        <div>去支付</div>
      </div>
      <div class="pay warn-pay" v-if="takeoutConfig.isBusiness==1 && userTakeoutInfo.deliveryType==1 && billHead.amount*100 < takeoutConfig.sendAmount">
        <div class="send-amount">{{parseData3((takeoutConfig.sendAmount*0.01)*1)}}</div>
        <div class="delta">{{parseData4(((takeoutConfig.sendAmount-billHead.amount*100)*0.01).toFixed(2)*1)}}</div>
      </div>
    </div>
    <addmemo ref="addmemo"></addmemo>
    <order-memo ref="ordermemo"></order-memo>

    <mustdialog :show="mustdialog" @onCancel="onCancel" :list="bidianMenu"  forceadd="0"></mustdialog>
  </div>
  <!--</transition>-->
</template>

<script>
  import ServiceHttp from '../../service/ServiceHttp'
  import ServiceUtil from '../../service/ServiceUtils'
  import ServiceDialog from '../../service/ServiceDialog'
  import addmemo from '../addMemo/addmemo';
  import BgYun from '../bg-yun/bgyun';
  import OrderMemo from '../orderMemo/orderMemo'
  import Mustdialog from "./mustdialog";

  export default {
    name: "TakeoutOrdered",
    data(){
      return{
        billDtl :[],
        suitBillDtl:[],
        billHead:{},
        userTakeoutInfo:{},
        takeoutConfig:{},
        mustdialog:false,
        bidianMenu:[]
      }
    },
    components:{
      Mustdialog,
      BgYun,
      addmemo,
      OrderMemo
    },
    props:{
      takeoutOrderedIsShow:false,
      takeOutBack:Function
    },

    methods:{
      parseData(data){
        return `(约${data}公里)`
      },
      parseData2(data){
        return `(满${data}元免配送费)`
      },
      parseData3(data){
        return `${data}元起送`
      },
      parseData4(data){
        return `差${data}元`
      },

      //去加菜
      clickGoAdd:function(){
        this.takeOutBack()
      },
      clickPayNext() {
            let postBillHead = {
                orderType: 2,
                qty: ServiceUtil.orderedTotal.qty,
                amount: ServiceUtil.orderedTotal.amount,
                tableNo: ServiceUtil.config.tableNo,
                distance: ServiceUtil.takeoutConfig.distance,
                orderScene:2
            };
            let bd = [];
            bd.append(ServiceUtil.noSuitBillData);
            //发现有code是空的直接清除掉
            for(let i in bd){
              let item = bd[i];
              if(item.code == 'bidian'){
                for(let j=0;j<item.menuItem.length;j++){
                  let item2 = item.menuItem[j];
                  if(!item2.code){
                    item.menuItem.splice(j,1);
                    j--;
                  }
                }
              }
            }
            if (ServiceUtil.suitBillData.length > 0) {
                bd.push({
                    code: '999999',
                    name: '套餐',
                    isGroup: "1",
                    menuItem: ServiceUtil.suitBillData
                });
            }
            if (this.userTakeoutInfo.deliveryType == 0) {//外卖下的自提,不需要计算配送费的
                let billMemo = this.billHead.billMemo;
                postBillHead.orderType = 1;       //订单类型改为自提，后台无需计算配送费
                postBillHead.memo = billMemo ? (billMemo + "\r\n" + this.userTakeoutInfo.timeText) : this.userTakeoutInfo.timeText;
            } else {
                if (!this.userTakeoutInfo.address || this.userTakeoutInfo.address == '') {
                    ServiceDialog.showAlert("温馨提示", "请填写配送地址!");
                    return;
                }
                if (!this.userTakeoutInfo.username || this.userTakeoutInfo.username == '') {
                    ServiceDialog.showAlert("温馨提示", "请填写联系人!");
                    return;
                }
                if (!this.userTakeoutInfo.tel || this.userTakeoutInfo.tel == '') {
                    ServiceDialog.showAlert("温馨提示", "请填写联系人电话!");
                    return;
                }
            }

            ServiceHttp.sendBill(postBillHead, bd, (res1) => {
                if (this.userTakeoutInfo.deliveryType == 0) {//外卖下的自提直接去支付
                    window.location.href = res1.resultUrl;
                } else if (this.userTakeoutInfo.deliveryType == 1) {//外卖的外送方式
                    let billMemo = this.billHead.billMemo;
                    var postData = {
                        outtradeno: res1.outtradeno,
                        contact: this.userTakeoutInfo.username,
                        address: this.userTakeoutInfo.address,
                        gdLat: this.userTakeoutInfo.gdLat,
                        gdLng: this.userTakeoutInfo.gdLng,
                        memo: billMemo ? (billMemo + "\r\n" + this.userTakeoutInfo.timeText) : this.userTakeoutInfo.timeText,
                        dispatchTime: this.userTakeoutInfo.time,
                        tel: this.userTakeoutInfo.tel
                    };
                    ServiceHttp.addOrderShippingInfo(postData, (res2) => {
                        window.location.href = res2.payurl;
                    });
                }
            });
        },
      //去支付
      clickGoPay() {
            let _orderedMap = {};
            ServiceUtil.noSuitBillData.forEach(type => {
                type.menuItem.forEach(item => {
                    _orderedMap[item.code] = true;
                })
            });
            //没有必点项

            if (ServiceUtil.bidianMenu.length <= 0) {
                this.clickPayNext();
            } else {
                let codes = [];
                ServiceUtil.bidianMenu.forEach(item=>{
                    if (!_orderedMap[item.code]) {
                        codes.push(item.code);
                    }
                });
                if(codes.length>0) {
                  this.mustdialog = true;
                  let bidianMenu = ServiceUtil.bidianMenu;
                  let arr = [];
                  for(let item of bidianMenu) {
                    if(codes.indexOf(item.code)!=-1){
                      arr.push({
                        code: item.code,
                        desc: item.desc,
                        drink: item.drink,
                        iconPath: item.iconPath,
                        id: item.id,
                        indexpicshow: item.indexpicshow,
                        memberNo: item.memberNo,
                        memberprice: item.memberprice,
                        memoflag: item.memoflag,
                        minOrderNum: item.minOrderNum,
                        name: item.name,
                        picMode: item.picMode,
                        picPath: item.picPath,
                        price: item.price,
                        remark: item.remark,
                        sndname: item.sndname,
                        sortNum: item.sortNum,
                        standard: item.standard,
                        standards: item.standards,
                        state: item.state,
                        menuItem: [],
                      })
                    }
                  }
                  this.bidianMenu = arr;
                    // ServiceDialog.confirm("温馨提示", "您有必点项没有点，您确定不需要吗？", () => {
                    //     this.clickPayNext();
                    // }, () => {
                    // }, "不需要", "去添加");
                }else{
                    this.clickPayNext();
                }
            }
        },

      onCancel(data){
        if(data){
          let flag = false;
          let yddata = [];//已点数据
          for(let item of this.billDtl){
            if(item.code=='bidian'){
              for(let item2 of item.menuItem){
                yddata.push(item2.code)
              }
              //判断已选的是否在已点的里，如果在就替换，不在就添加
              for(let item3 of data){
                if(yddata.indexOf(item3.code) == -1) { //不在
                  item.menuItem.push(item3)
                }
              }
              flag = true;
              break;
            }
          }
          if(!flag){
            let menu = {code: "bidian", ename: "", isGroup: 0, menuItem: data, name: "必点项"}
            this.billDtl.push(menu);
          }
          ServiceUtil.noSuitBillData = this.billDtl;
          ServiceUtil.calculateCarTotal();
          ServiceUtil.calculateTypeNum();
        }else{
          this.clickPayNext();
        }
        this.mustdialog = false;
      },
      editDelivery(){
          var obj = Object.assign({},ServiceUtil.takeoutConfig);
          obj.bnText = "保存";
          ServiceDialog.OpenUserTakeoutSet(obj);
      },
      /**
       * 点击减号
       * */
      clickSub(type,order,index){
        console.log(order);
        var doDelete = function(){
          order.num--;
          if(order.num < ServiceUtil.menuItemDataMap[order.code].minOrderNum || 0){
            order.num = 0;
          }
          order.num = Math.max(0,order.num);
          if(order.num == 0){
            type.menuItem.splice(index,1);
          }
          ServiceUtil.calculateCarTotal();
          ServiceUtil.calculateTypeNum();
        };
        var _str ="您确定删除该菜品吗？";

        if((ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)>1){
          _str = "该菜品最小点菜数量为{0}份，您确定删除该菜品吗？".format(ServiceUtil.menuItemDataMap[order.code].minOrderNum );
        }

        if(order.num <= (ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)){
          ServiceDialog.confirm('温馨提示',_str,()=>{
            doDelete();
          });
        }else {
          doDelete();
        }



      },
      /**
       * 点击加号
       * @param type
       * @param order
       */
      clickAdd(type,order){
        order.num++;
        order.num = Math.max(0,order.num);
        ServiceUtil.calculateCarTotal();
        ServiceUtil.calculateTypeNum();
      },
      /**
       * 点击套餐减号
       * */
      clickSuitSub(suit,order,index){
        var doDelete = function(){
          order.num--;
          if(order.num < (ServiceUtil.menuItemDataMap[order.code].minOrderNum || 0)){
            order.num = 0;
          }
          order.num = Math.max(0,order.num);
          if(order.num == 0){
            suit.splice(index,1);
          }
          ServiceUtil.calculateCarTotal();
          ServiceUtil.calculateTypeNum();
        };

        var _str ="您确定删除该菜品吗？";

        if((ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)>1){
          _str = "该菜品最小点菜数量为{0}份，您确定删除该菜品吗？".format(ServiceUtil.menuItemDataMap[order.code].minOrderNum );
        }

        if(order.num <= (ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)){
          ServiceDialog.confirm('温馨提示',_str,()=>{
            doDelete();
          });
        }else {
          doDelete();
        }

      },
      /**
       * 点击套餐加号
       * @param type
       * @param order
       */
      clickSuitAdd(order){
        order.num++;
        order.num = Math.max(0,order.num);
        ServiceUtil.calculateCarTotal();
        ServiceUtil.calculateTypeNum();
      },
      //点击菜品名称 添加备注
      clickOrder(order){
        this.$refs.addmemo.togglebox(order,()=>{})
      },
      addOrderMemo(){
          this.$refs.ordermemo.togglebox();
      }
    },
    mounted(){
      this.billHead = ServiceUtil.orderedTotal;
      this.billDtl  = ServiceUtil.noSuitBillData;
      this.suitBillDtl = ServiceUtil.suitBillData;
      this.userTakeoutInfo = ServiceUtil.userTakeoutInfo;
      this.takeoutConfig = ServiceUtil.takeoutConfig;

      console.log("xxx,",ServiceUtil.bidianMenu);
      console.log("yyy,",this.billDtl);
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/style";
  .magin-t-6{
    margin-top: 6px;
  }
  .content{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0px;
    background-color: #7B653F;
    padding: 4px 4px 65px 4px;
    overflow: auto;
    .takeout{
      border-radius: 5px;
      overflow: hidden;
      font-size: 1.1rem;
    }
    .menu{
      margin-top: 10px;
      border-radius: 5px;
      overflow: hidden;
      .typename{background-color: #F6F3E8;}
      .order-num{width: 25px;height: 25px;text-align: center;line-height: 25px;border: 1px solid rgba(140, 64, 22, 0.29);border-radius: 3px;}
      .line-solid{border-bottom: 0.5px solid rgba(180, 142, 90, 0.37);}
    }
    .memo{
      margin-top: 10px;
      border-radius: 5px;
      overflow: hidden;
      .right-icon{
        transform: rotate(180deg);
        vertical-align: middle;
      }
    }
  }

  .border-t-dash{border-top: 1px dashed #ddd}


  .footer{
    $radius:50px;
    position: absolute;
    height: 48px;
    overflow: hidden;
    bottom: 5px;
    left: 5px;
    right: 5px;
    background-color: #000000;
    border-radius: $radius;
    font-size: 1rem;
    .amount{
      text-align: center;
      flex: 1;
      .order-amount{
        font-size: 1.3rem;
        color: #EA432E;
        span{
          font-size: 0.7rem;
        }
      }
      .delivery-amount{
        font-size: 0.8rem;
        color: #FFFFFF;
      }
    }
    .add-order{
      background-color: #BF9E61;
      border-top-left-radius: $radius;
      border-bottom-left-radius: $radius;
      width:100px;
      height: 100%;
      color: #FFFFFF;
      display: flex;
      flex-direction: column;
      align-items:center;
      justify-content: center;
      font-size: 1rem;
    }
    .pay{
      width: 100px;
      height: 100%;
      border-bottom-right-radius: $radius;
      border-top-right-radius: $radius;
      color: #FFFFFF;
      display: flex;
      flex-direction: column;
      align-items:center;
      justify-content: center;
      .send-amount{
        font-size: 0.9rem;
      }
      .delta{
        font-size: 0.7rem;
      }
    }
    .pay.un-business{
      background-color: #EA432E;
    }
    .pay.go-pay{
      background-color: #0DC161;
    }
    .pay.warn-pay{
      background-color: #FF6D00;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ordered/takeoutOrdered.vue